/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/aha" */ '@atlassian/logo-third-party/aha'
		).then((m) => m.AhaIcon),
	{ moduleId: '@atlassian/logo-third-party/aha' },
);

const LazyAhaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-aha" */ './utils').then((m) => m.AhaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/aha/icon' },
);

const LazyAhaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-aha-search-result" */ './utils').then(
			(m) => m.AhaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AhaIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyAhaIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const AhaSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyAhaSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
